import { mapDictionaryKey } from "components/Filters/helpers";

import { ResourcesSuggestions, SEARCH_MANAGED_ENTITIES_SUGGESTIONS_DICTIONARY } from "./constants";

export const getFilterKey = (key: ResourcesSuggestions | string) => {
  return mapDictionaryKey(key, SEARCH_MANAGED_ENTITIES_SUGGESTIONS_DICTIONARY);
};
